<template>
  <div>
    <calculator-engine />
  </div>
</template>

<script>
import CalculatorEngine from '@/components/calculator/CalculatorEngine.vue';

export default {
  components: {
    CalculatorEngine,
  },
};
</script>

<style>

</style>
